/**
 * @fileoverview Agent definition for world-element-rare-detector-v3.
 *
 * Inferential detection of world elements using rules embedded in dialogue,
 * sensory staging in description, and biological details mentioned in passing.
 *
 * @category world-building.extraction.detection
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-element-rare-detector-v3',
  kind: 'primitive',
  name: 'World Element Rare Detector',
  description: 'Inferential detection of world elements. Primary: Set, Species, System. Also catches subtle Place, Organization, Object, Event.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.extraction.detection',
    usedBy: [],
    usedInComposites: ['extract-world-elements-v3'],
    relatedAgents: [
      'world-element-core-detector-v3',
      'world-element-detailer-v3',
    ],
  },
};
